import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var AdminDashboardRes;
export const AdminDashboardTodo = createAsyncThunk('AdminDashboard', async (data) => {
    // console.log("data", data)
    const type = localStorage.getItem('userrole')
    try {
        const res = await axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + 'admin_dashboard',
            // params: {
            //     'fromDate': '',
            //     'toDate': '',
            //     'user_id': localStorage.getItem('userId')
            // },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('token') },

        })
        return AdminDashboardRes = res.data

    } catch (error) {
        return AdminDashboardRes = error.response.data
    }
});

const AdminDashboardSlice = createSlice({
    name: 'AdminDashboard',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(AdminDashboardTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(AdminDashboardTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default AdminDashboardSlice.reducer; 